<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">{{$store.state.themeTitle}}室安全工作年度报告</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="年份">
          <el-date-picker v-model="formInline.year" value-format="yyyy" type="year" placeholder="请选择年份" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择学期">
            <el-option v-for="(item,index) in $store.state.terms" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd()">新增年度报告</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="year" label="年度">
        </custom-table-column>
        <custom-table-column prop="term" label="学期">
        </custom-table-column>
        <!-- <custom-table-column prop="structure_1" label="院系">
        </custom-table-column> -->
        <custom-table-column prop="created_at" label="提交时间">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleDetail(scope.row.id)" type="text" size="small">详情</el-button>
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>

          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="在线填报" :visible.sync="centerDialogVisible" width="1000px">
      <Report ref="Report" @getList="handleSonQuery" :type="type" :ruleForm="ruleForm" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{delText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import Report from './components/report';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      classRooms: [],
      ruleForm: {
        school_name: '',
        department_t: '',
        head: '',
        link: '',
        phone: '',
        email: '',
        date: '',
        year: '',
        term:'',
        tableJson: {
          table_8_1: {
            shuoming: '',
          },
          table_7_1: {
            gaikuang1: '',
            qingkuan1: '',
            yiyi1: '',
            gaikuang2: '',
            qingkuan2: '',
            yiyi2: '',
            gaikuang3: '',
            qingkuan3: '',
            yiyi3: '',
          },
          table_6_2_1: {
            shuoming: '',
          },
          table_6_1_2: {
            shifou1: '',
            shifou2: '',
            shifou3: '',
            shuoming: '',
          },
          table_6_1_1: {
            shu1: '',
            shu2: '',
            shuoming: '',
          },
          table_5_2: {
            shu1: '',
            shu2: '',
            shu3: '',
            shu4: '',
            shuoming: '',
          },
          table_5_1: {
            shifou1: '',
            wenjian1: '',
            shifou2: '',
            wenjian2: '',
            shifou3: '',
            wenjian3: '',
            shifou4: '',
            wenjian4: '',
            shuoming: '',
          },
          table_4_1: {
            qingkuan: [
              {
                nianfen: '',
                jibie: '',
                zuzhimingcheng: '',
                jianchamingcheng: '',
                jianchaneirong: '',
                riqi: '',
                yhshuliang: '',
                yhneirong: '',
                yhwcshuliang: '',
                yuanyin: '',
              },
            ],
            shuoming: '',
          },
          table_3_3: {
            shifou1: '',
            wenjian1: '',
            shifou2: '',
            wenjian2: '',
            shifou3: '',
            wenjian3: '',
            shifou4: '',
            wenjian4: '',
            shuoming: '',
          },
          table_3_2_2: [
            {
              leibie: '',
              mingcheng: '',
              chubanshu: '',
              riqi: '',
              bianhao: '',
              bianzhe: '',
            },
          ],
          table_3_2_1: {
            shu1: '',
            shu2: '',
            shu3: '',
            shu4: '',
            shu5: '',
            shuoming: '',
          },
          table_3_1: {
            shu1: '',
            shu2: '',
            shuoming: '',
          },
          table_2_3: {
            wenjian: [
              {
                jibie: '',
                wenhao: '',
                mingcheng: '',
                riqi: '',
              },
            ],
            shuoming: '',
          },
          table_2_2: {
            shifou1: '',
            wenjian1: '',
            shuoming: '',
          },
          table_2_1: {
            shifou1: '',
            wenjian1: '',
            shifou2: '',
            wenjian2: '',
            shifou3: '',
            wenjian3: '',
            shifou4: '',
            wenjian4: '',
            shifou5: '',
            wenjian5: '',
            shuoming: '',
          },
          table_1_3: [
            {
              nianfen: '',
              leixin: '',
              mingcheng: '',
              guocheng: '',
              riqi: '',
              shang: '',
              wang: '',
              sunshi: '',
              yuanyin: '',
            },
          ],
          table_1_1: {
            school_name: '',
            department: '',
            number: '',
            area: '',
            funds: '',
            fundsToSafe: '',
            fundsToTrain: '',
          },
          table_1_2: {
            yiju: [],
            yijubuchong: '',
            yijushuoming: '',
            zhuanzhizongshu: '',
            zhuanzhibili: '',
            boshishu1: '',
            boshibili1: '',
            shuoshishu1: '',
            shuoshibili1: '',
            benkeshu1: '',
            benkebili1: '',
            qitaxuelishu1: '',
            qitaxuelibili1: '',
            zhenggaojishu1: '',
            zhenggaojibili1: '',
            fugaojishu1: '',
            fugaojibili1: '',
            zhongjishu1: '',
            zhongjibili1: '',
            chujishu1: '',
            chujibili1: '',
            qitazhichenshu1: '',
            qitazhichenbili1: '',
            shiyanshu1: '',
            shiyanbili1: '',
            jiaoxueshu1: '',
            jiaoxuebili1: '',
            keyanshu1: '',
            keyanbili1: '',
            qitagangweishu1: '',
            qitagangweibili1: '',
            zizhishu1: '',
            zizhibili1: '',

            jianzhizongshu: '',
            jianzhibili: '',
            boshishu2: '',
            boshibili2: '',
            shuoshishu2: '',
            shuoshibili2: '',
            benkeshu2: '',
            benkebili2: '',
            qitaxuelishu2: '',
            qitaxuelibili2: '',
            zhenggaojishu2: '',
            zhenggaojibili2: '',
            fugaojishu2: '',
            fugaojibili2: '',
            zhongjishu2: '',
            zhongjibili2: '',
            chujishu2: '',
            chujibili2: '',
            qitazhichenshu2: '',
            qitazhichenbili2: '',
            shiyanshu2: '',
            shiyanbili2: '',
            jiaoxueshu2: '',
            jiaoxuebili2: '',
            keyanshu2: '',
            keyanbili2: '',
            qitagangweishu2: '',
            qitagangweibili2: '',
            zizhishu2: '',
            zizhibili2: '',
          },
        },
      },
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      levell: [1],
      formInline: {
        year: '',
        term: '',
      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.handleAdd();
  },
  components: {
    Report,
  },
  methods: {
    async handleDetail(id) {
      this.type = 'detail'
      let res = await this.$api.instance.interfaceServer('api/annual/report/detail', 'post', { id });
      if (res.code == 0 && res.data) {
        this.ruleForm = {
          // id,
          school_name: this.$store.state.userInfo.school_name,
          department_t: res.data.department_t,
          head: res.data.head,
          link: res.data.link,
          phone: res.data.phone,
          email: res.data.email,
          date: res.data.date,
          year: res.data.year,
          term: res.data.term,
          tableJson:JSON.parse(res.data.tableJson)
        };
        if(this.ruleForm.tableJson.table_2_3.wenjian){
          this.ruleForm.tableJson.table_2_3.wenjian = JSON.parse(this.ruleForm.tableJson.table_2_3.wenjian)
        }
        console.table(this.ruleForm)
        this.centerDialogVisible = true
      }
    },
    handleSonQuery(){
      this.centerDialogVisible=false
      this.getList()
    },
    handleAdd() {
      this.type = 'add';
      if (this.selectName) {
        this.selectName = '';
      }
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      if (localStorage.getItem('yearReport')) {
        this.ruleForm = JSON.parse(localStorage.getItem('yearReport'));
      }
      this.ruleForm.school_name = this.ruleForm.tableJson.table_1_1.school_name = this.$store.state.userInfo.school_name;
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },

    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    getOrganList() {
      if (this.selectNode.level == 1) {
        this.ruleForm.structure_1 = this.selectNode.structure_names;
      } else {
        this.ruleForm.structure_1 = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/annual/report/myList/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatTrainBase() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTrainBase() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/annual/report/myList', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
